import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import { getButtonsNoYesDanger } from 'context/helpers/helperModalContext';
import SvgTrash from 'components/svg/SvgTrash';
import type { ProductSetType } from '@econtractor/types';

const useDeleteProductSet = () => {
    const { t } = useTranslation(['Sets']);
    const { showDlg } = useModal();

    const paramsDelDlg = {
        buttons: [...getButtonsNoYesDanger(t)],
        type: 'confirm',
    };

    const deleteProductSet = (productSet: ProductSetType, cbFunct: () => void) => {
        const p: any = {
            ...paramsDelDlg,
            text: (
                <>
                    <h4 className="d-flex pb-2 mb-2 border-bottom text-danger">
                        <SvgTrash className="text-danger" />
                        <span className="ps-2">{t('setPopup.delete')}?</span>
                    </h4>
                    <h5 className="mb-0">{productSet.setName}</h5>
                    {productSet.setDescription ? (
                        <small className="form-text text-muted">{productSet.setDescription}</small>
                    ) : null}
                </>
            ),
        };

        p.buttons[1].handleClick = () => {
            showDlg(false);
            cbFunct();
        };
        showDlg(p);
    };

    return {
        deleteProductSet,
    };
};

export default useDeleteProductSet;
